import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Grid } from '@material-ui/core';
import Tooltip from "@material-ui/core/Tooltip";

import { toGermanFormat } from '../../../../../../../../utils/numberFormater'

import useStyles from './styles'

function ExAnteLine(props) {

  const {
    title,
    euroValue,
    percentValue,
    divider,
    bold,
    subTitle,
    style,
    numbersTooltip,
    withBorder,
    children
  } = props;

  const classes = useStyles();

  const content = (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <span className={clsx(classes.label, bold && classes.textBold, subTitle && classes.subTitle)} style={style}>
          { title }
        </span>
      </Grid>
      { !divider && (
        <>
          <Grid item xs={3}>
            <span className={clsx(classes.label, classes.alignRight, bold && classes.textBold)}>
              {numbersTooltip ? (
                <Tooltip
                  classes={{tooltip: classes.tooltip}}
                  title={numbersTooltip}
                  placement={"top"}
                  arrow>
                  <span>{(percentValue || percentValue == 0) ? toGermanFormat(percentValue * 100, undefined, ' %') : ''}</span>
                </Tooltip>
              ) : (
                <>{(percentValue || percentValue == 0) ? toGermanFormat(percentValue * 100, undefined, ' %') : ''}</>
              )}
            </span>
          </Grid>
          <Grid item xs={3}>
            <span className={clsx(classes.label, classes.alignRight, bold && classes.textBold)}>
              {numbersTooltip ? (
                <Tooltip
                  classes={{tooltip: classes.tooltip}}
                  title={numbersTooltip}
                  placement={"top"}
                  arrow>
                  <span>{(euroValue || euroValue == 0) ? toGermanFormat(euroValue, undefined, ' €') : ''}</span>
                </Tooltip>
              ) : (
                <>{ (euroValue || euroValue == 0) ? toGermanFormat(euroValue, undefined, ' €') : '' }</>
              )}
            </span>
          </Grid>
        </>
      )}
    </Grid>
  );

  return (
    <Grid item xs={12} className={clsx(!subTitle && classes.lineWrapper, withBorder && classes.withBorder)}>
      {!!children ? (
        <>
          <Grid container spacing={1}>
            <Grid item xs={12}>{content}</Grid>
            {children}
          </Grid>
        </>
      ) : content}
    </Grid>
  )
}

ExAnteLine.propTypes = {
  /** Line title */
  title: PropTypes.string.isRequired,
};

export default ExAnteLine

